import React, { Component } from 'react';
import ReactTable from 'react-table';
import axios from 'axios';
import { Configurations } from '../../Utils/Configurations';
import moment from 'moment';
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import NewUser from './New-User';
import ModalUserAccess from './../../Components/Modal-User-Access/Modal-User-Access';
import 'react-table/react-table.css';
import './Users-List.scss';

class UsersList extends Component {
    constructor() {
        super();

        this.getUsersList = this.getUsersList.bind(this);
        this.refreshTable = this.refreshTable.bind(this);
        this.closeNewUser = this.closeNewUser.bind(this);
        this.openNewUser = this.openNewUser.bind(this);
        this.disableUser = this.disableUser.bind(this);
        this.toggleModalAccess = this.toggleModalAccess.bind(this);
        this.loadModalAccess = this.loadModalAccess.bind(this);
        this.updateAccess = this.updateAccess.bind(this);

        this.Configurations = new Configurations();

        this.state = {
            usersList: [],
            modalNewUserOpen: false,
            modalAccess: false,
            arrPerm: [],
            idAccessEdit: '',
            isLoadingUpdateAccess: false,
        }

        this.columns = [
            {
                Header: 'Id',
                accessor: 'id',
                className: 'text-center pointer',
                width: 40
            },
            {
                Header: 'Nome',
                accessor: 'nome',
                className: 'text-left pointer',
                width: 180
            },
            {
                Header: 'E-mail',
                accessor: 'email',
                className: 'text-left pointer',
                width: 210
            },
            {
                id: 'dtCriacao',
                Header: 'Data Criação',
                accessor: d => {
                    return moment(d.dtCriacao)
                        .local()
                        .format("DD/MM/YYYY HH:mm:ss")
                },
                className: 'text-center pointer',
                width: 180
            },
            {
                id: 'status',
                Header: 'Status',
                accessor: d => {
                    return d.ativo === 1 ? (<span className="badge badge-primary">Ativo</span>) : (<span className="badge badge-danger">Inativo</span>)
                },
                className: 'text-center pointer',
                width: 80
            },
            // {
            //     Header: 'Role',
            //     accessor: "id",
            //     className: 'text-center pointer',
            //     width: 80
            // },
            {
                id: "desativar",
                Header: '',
                accessor: d => {
                    // return (<div><i className={`fas fa-${d.ativo === 1 ? 'lock' : 'unlock'}`}></i></div>);
                    const _ativo = d.ativo === 1,
                        // _functionBtn = _publicado ? "desativar" : "publicar",
                        // _textTooltip = _publicado ? "desativar edição" : "publicar edição";
                        _classIcon = _ativo ? `fas fa-toggle-on` : `fas fa-toggle-off`;
                    return (
                        <div className="row no-gutters">
                            <div className="col-12 icones">
                                <button onClick={() => this.disableUser(d.id, (d.ativo === 1 ? 0 : 1))}>
                                    <i className={`${_classIcon}`}></i>
                                </button>
                            </div>
                        </div>
                    );
                },
                className: 'text-center pointer',
                width: 60
            },
            {
                Header: '',
                className: 'pointer text-center text-danger',
                Cell: row => <button onClick={() => this.loadModalAccess(row.original.permissions, row.original.id)} disabled={row.original.ativo === 0} className="btn btn-sm btn-outline-info">alterar acesso</button>,
                width: 150
            },
        ];
        this.permissionsMOCK = [
            { numero: 1, dtCriacao: '' },
            { numero: 2, dtCriacao: '' },
            { numero: 4, dtCriacao: '' },
        ]
    }

    refreshTable(o) {
        this.getUsersList(o);
    }

    closeNewUser() {
        this.setState({
            modalNewUserOpen: false
        });
    }

    openNewUser() {
        this.setState({
            modalNewUserOpen: true
        });
    }

    getUsersList(o) {
        const _users = axios.get(this.Configurations.apiBasePath + `/usuarios/lista`);

        _users.then(response => {
            this.setState({
                usersList: response.data.usuarios,
                loading: false
            });
        }).catch(err => {
            console.log(err);
        });
    }

    disableUser(id, status) {
        this.setState({ isLoading: true });
        const _service = axios.post(this.Configurations.apiBasePath + `/usuario/mudar-status/${id}`, { "status": status });
        _service.then(response => {

            this.setState({ isLoading: false });
        }).catch(err => {
            this.setState({ isLoading: false });
        }).finally(() => this.refreshTable());
    }

    loadModalAccess(_arrPerm, _id) {
        this.setState({
            arrPerm: _arrPerm,
            idAccessEdit: _id
        }, () => this.toggleModalAccess());
    }

    toggleModalAccess() {
        this.setState({
            modalAccess: !this.state.modalAccess
        })
    }

    updateAccess(_id, _newArrPerm) {
        // const arrayPerm = _newArrPerm.filter(item => item.checked).map((perm, index) => {
        //     return perm.numero
        // });
        // const _newAccess = {
            //     idUserAccess: _id,
            //     permissions: arrayPerm
        // }
        // console.log(_newAccess)


        this.setState({ isLoadingUpdateAccess: true });
        const arrayPerm = _newArrPerm.filter(item => item.checked).map((perm, index) => {
            return perm.idPermissao
        });
        const _service = axios.post(this.Configurations.apiBasePath + `/usuario/permissoes/${_id}`, { "permissions": arrayPerm });
        _service.then(response => {

            this.setState({ isLoadingUpdateAccess: false });
        }).catch(err => {
            this.setState({ isLoadingUpdateAccess: false });
        }).finally(() => this.refreshTable());

    }


    render() {
        return (
            <div className="users-list">
                <div className="row">
                    <div className="col-10">
                        <h2 className="title-1">Usuários</h2>
                    </div>
                    <div className="col-2 text-right">
                        <button className="btn btn-outline-success" onClick={this.openNewUser}>Novo usuário</button>
                    </div>
                </div>
                <div className="row mt-4">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-body p-0">
                                <ReactTable
                                    data={this.state.usersList}
                                    columns={this.columns}
                                    onFetchData={this.refreshTable}
                                    defaultPageSize={20}
                                    pages={this.state.pages}
                                    manual
                                    loading={this.state.loading}
                                    className="-striped -highlight"
                                    headerClassName="ebs-table-header"
                                    previousText='Anterior'
                                    nextText='Próximo'
                                    loadingText='Carregando...'
                                    noDataText='Nenhum usuário encontrado.'
                                    pageText='Página'
                                    ofText='de'
                                    rowsText='linhas'
                                    getTdProps={(state, rowInfo, column, instance) => {
                                        return {
                                            onClick: (e, handleOriginal) => {
                                                if (rowInfo) {
                                                    if (column.id === "desativar") handleOriginal();
                                                    // else this.selecionaEdicao(rowInfo.original.numeroEdicao)
                                                }
                                            }
                                        }
                                    }}
                                />

                            </div>
                        </div>
                    </div>
                </div>

                <Modal isOpen={this.state.modalNewUserOpen} toggle={this.toggleModalItem} className="" size="lg">
                    <ModalBody>
                        <NewUser 
                        close={this.closeNewUser} 
                        refresh={this.refreshTable}
                        />
                    </ModalBody>
                </Modal>
                
                <Modal size='lg' isOpen={this.state.modalAccess} toggle={this.toggleModalAccess}>
                    <ModalHeader toggle={this.toggleModalAccess}>Níveis de Acesso</ModalHeader>
                    <ModalBody>
                        <ModalUserAccess
                            arrPerm={this.state.arrPerm}
                            toggle={this.toggleModalAccess}
                            isOpen={this.state.modalAccess}
                            idAccessEdit={this.state.idAccessEdit}
                            updateAccess={this.updateAccess}
                            loading={this.state.isLoadingUpdateAccess}
                        />
                    </ModalBody>
                </Modal>
                {/* <ModalUserAccess
                    arrPerm={this.state.arrPerm}
                    toggle={this.toggleModalAccess}
                    isOpen={this.state.modalAccess}
                /> */}
            </div>
        )
    }
}

export default UsersList;
